import React from 'react';
import { TranslationUtils, CurrencyUtils } from '../../utils';
import './ConvertedCurrencyNotice.scss';
import { ReceiptLineSummary } from './ReceiptLineSummary';

interface ConvertedCurrencyNoticeProps {
    convertedCurrency: string;
    convertedTotal: number;
    originalCurrency: string;
    originalTotal: number;
    locale: string;
}

export const ConvertedCurrencyNotice: React.FC<ConvertedCurrencyNoticeProps> = (props) => {
    const { convertedCurrency, convertedTotal, originalCurrency, originalTotal, locale } = props;

    return (
        <React.Fragment>
            <div className="total-in-converted-currency">
                <div>
                    <span
                        className={'body-bold'}
                        tabIndex={0}
                        aria-label={`${TranslationUtils.get('total_in', { currency: convertedCurrency })} ${convertedTotal}`}
                    >
                        {TranslationUtils.get('total_in', { currency: convertedCurrency })}
                    </span>
                </div>
                <div className="total-in-converted-currency-value">
                    <span className={'body-bold'}>{CurrencyUtils.formatCurrency(convertedTotal, convertedCurrency, locale)}</span>
                </div>
            </div>

            <div className="converted-currency-note">
                <div>
                    <span className={'body-regular'} tabIndex={0}>
                        {TranslationUtils.get('processed_in_currency_notice', { currency: originalCurrency })}
                    </span>
                </div>
            </div>

            <div className="total-in-original-currency">
                <ReceiptLineSummary
                    summaryTitle={TranslationUtils.get('total_in', { currency: originalCurrency })}
                    summaryValue={originalTotal}
                    currency={originalCurrency}
                    locale={locale}
                />
            </div>
            <hr />
        </React.Fragment>
    );
};
